/* eslint-disable no-unused-vars */
export const FileType = {
  SOLICITUD: 'SOLICITUD',
  CHEQUERA: 'CHEQUERA',
  ESTADO_CUENTA: 'ESTADO_CUENTA',
  LIBRE_DEUDA: 'LIBRE_DEUDA',
  CERTIFICADO_PRECANCELACION: 'CERTIFICADO_PRECANCELACION',
};

export const questions = [
  { title: 'Préstamos en efectivo', link: 'https://www.directo.com.ar/preguntas-frecuentes/#prstamos-en-efectivo' },
  { title: 'Compra en cuotas fijas', link: 'https://www.directo.com.ar/preguntas-frecuentes/#compra-en-cuotas-fijas' },
  {
    title: 'Compra en cuotas sin interés',
    link: 'https://www.directo.com.ar/preguntas-frecuentes/#compra-en-cuotas-sin-inters',
  },
  { title: 'Mi directo', link: 'https://www.directo.com.ar/preguntas-frecuentes/#mi-directo' },
  { title: 'Preguntas frecuentes', link: 'https://www.directo.com.ar/preguntas-frecuentes/' },
];
